import axios from "../../../config/axios";

export default {
  obtener,
};

function obtener(id) {
  if (id) {
    return axios.get(`${axios.defaults.baseUrl}/api/archivoPublico/${id}`)
      .then(resp => resp.data);
  }
  return {};
}



// WEBPACK FOOTER //
// ./src/components/notas/rest/archivoApi.js